import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
	isUserInRoles,
	rolesAllowed,
	USER_ROLES
} from '../../shared/security/RolesAllowed';
import { settingsSections } from './settingsSections';

@rolesAllowed([USER_ROLES.ADMIN, USER_ROLES.MANAGER])
@withRouter
export class Settings extends React.Component {
	render() {
		if (this.isSubSection()) {
			return null;
		}

		return (
			<div className="Settings container">
				<Fragment>
					<div className="level ListHeader">
						<div className="level-left">
							<h1 className="title">Settings</h1>
						</div>
					</div>
				</Fragment>
				<div className="settings-cards-grid">
					{settingsSections
						.filter(item => isUserInRoles(item.rolesAllowed))
						.map(item => (
							<Link
								key={item.section}
								className="settings-card-item"
								to={`/ats/settings/${item.section}`}>
								<div className="card">
									<div className="card-content is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center">
										{item.icon && (
											<span className="is-size-2 mr-4" aria-hidden="true">
												<i className={item.icon} />
											</span>
										)}
										<p className="settings-card-label is-flex-grow-1">
											{item.label}
										</p>
									</div>
								</div>
							</Link>
						))}
				</div>
			</div>
		);
	}

	isSubSection() {
		return this.props.location.pathname.replace('/', '').split('/').length >= 3;
	}
}
